import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(form.email, form.password);
      toast.success("Welcome back!");
      nav(data.kind === "admin" ? "/admin" : "/account");
    } catch (e) { toast.error(apiErr(e)); } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-20">
      <h1 className="font-display text-3xl font-bold text-center">Sign in</h1>
      <p className="text-center text-zinc-500 text-sm mt-2">Welcome back to Qava</p>
      <form onSubmit={submit} className="space-y-4 mt-8">
        <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" /></div>
        <div><Label>Password</Label><Input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" /></div>
        <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="login-submit">{loading ? "Signing in..." : "Sign in"}</Button>
      </form>
      <p className="text-center text-sm text-zinc-500 mt-6">No account? <Link to="/register" className="text-zinc-900 font-medium underline">Create one</Link></p>
    </div>
  );
}

export function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await register(form); toast.success("Account created!"); nav("/account"); }
    catch (e) { toast.error(apiErr(e)); } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-20">
      <h1 className="font-display text-3xl font-bold text-center">Create account</h1>
      <form onSubmit={submit} className="space-y-4 mt-8">
        <div><Label>Full name</Label><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="reg-name" /></div>
        <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="reg-email" /></div>
        <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="reg-phone" /></div>
        <div><Label>Password</Label><Input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reg-password" /></div>
        <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="reg-submit">{loading ? "Creating..." : "Create account"}</Button>
      </form>
      <p className="text-center text-sm text-zinc-500 mt-6">Already have an account? <Link to="/login" className="text-zinc-900 font-medium underline">Sign in</Link></p>
    </div>
  );
}
